import { Redirect, useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';

import {
  CAMPAIGN_OG_DESCRIPTION,
  CAMPAIGN_OG_IMAGE,
  CAMPAIGN_OG_IMAGE_HEIGHT,
  CAMPAIGN_OG_IMAGE_WIDTH,
  CAMPAIGN_OG_TITLE,
  CAMPAIGN_OG_URL,
} from '@/constants/giftingOg';

/**
 * Public alias matching the campaign's brand name: /campus-drop →
 * /season-of-gifting. The blast, social posts, and (since the share-preview
 * fix) every in-app share link point here. Query params are forwarded so
 * ?ref= attribution survives the hop.
 *
 * This route carries the campaign's OG tags even though it immediately
 * redirects, and that is the entire point: scrapers read the exported
 * `campus-drop.html` and never run the JS that performs the redirect, so
 * these tags — not the destination's — are what iMessage renders. Without
 * them the branded link previewed as the generic "Get paid for signing up"
 * card, which is the opposite of what a free-gift campaign should look
 * like in a text message.
 */
export default function CampusDropAlias() {
  const params = useLocalSearchParams<Record<string, string>>();
  return (
    <>
      <Head>
        <title>{CAMPAIGN_OG_TITLE}</title>
        <meta name="description" content={CAMPAIGN_OG_DESCRIPTION} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={CAMPAIGN_OG_TITLE} />
        <meta property="og:description" content={CAMPAIGN_OG_DESCRIPTION} />
        <meta property="og:image" content={CAMPAIGN_OG_IMAGE} />
        <meta property="og:image:width" content={CAMPAIGN_OG_IMAGE_WIDTH} />
        <meta property="og:image:height" content={CAMPAIGN_OG_IMAGE_HEIGHT} />
        <meta property="og:url" content={CAMPAIGN_OG_URL} />
        {/* Route-level twitter:* overrides: X prefers twitter tags, and the
            root layout's are the generic app pitch. Same for image dims. */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={CAMPAIGN_OG_TITLE} />
        <meta name="twitter:description" content={CAMPAIGN_OG_DESCRIPTION} />
        <meta name="twitter:image" content={CAMPAIGN_OG_IMAGE} />
      </Head>
      <Redirect href={{ pathname: '/season-of-gifting', params }} />
    </>
  );
}
